// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file i18n/v3/language_regions.proto (package i18n.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file i18n/v3/language_regions.proto.
 */
export const file_i18n_v3_language_regions: GenFile = /*@__PURE__*/
  fileDesc("Ch5pMThuL3YzL2xhbmd1YWdlX3JlZ2lvbnMucHJvdG8SB2kxOG4udjMq1wkKDkxhbmd1YWdlUmVnaW9uEh8KG0xBTkdVQUdFX1JFR0lPTl9VTlNQRUNJRklFRBAAEhkKFUxBTkdVQUdFX1JFR0lPTl9FTl9VUxABEhkKFUxBTkdVQUdFX1JFR0lPTl9FTl9HQhACEhkKFUxBTkdVQUdFX1JFR0lPTl9FTl9DQRADEhkKFUxBTkdVQUdFX1JFR0lPTl9FTl9BVRAEEhkKFUxBTkdVQUdFX1JFR0lPTl9FTl9JThAFEhkKFUxBTkdVQUdFX1JFR0lPTl9aSF9DThAKEhkKFUxBTkdVQUdFX1JFR0lPTl9aSF9UVxALEhkKFUxBTkdVQUdFX1JFR0lPTl9aSF9ISxAMEhkKFUxBTkdVQUdFX1JFR0lPTl9aSF9TRxANEhkKFUxBTkdVQUdFX1JFR0lPTl9ERV9ERRAUEhkKFUxBTkdVQUdFX1JFR0lPTl9ERV9BVBAVEhkKFUxBTkdVQUdFX1JFR0lPTl9ERV9DSBAWEhkKFUxBTkdVQUdFX1JFR0lPTl9ERV9MVRAXEhkKFUxBTkdVQUdFX1JFR0lPTl9KQV9KUBAeEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19FUxAoEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19NWBApEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19BUhAqEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19DTxArEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19DTBAsEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19QRRAtEhkKFUxBTkdVQUdFX1JFR0lPTl9FU19WRRAuEhkKFUxBTkdVQUdFX1JFR0lPTl9GUl9GUhAyEhkKFUxBTkdVQUdFX1JFR0lPTl9GUl9DQRAzEhkKFUxBTkdVQUdFX1JFR0lPTl9GUl9CRRA0EhkKFUxBTkdVQUdFX1JFR0lPTl9GUl9DSBA1EhkKFUxBTkdVQUdFX1JFR0lPTl9BUl9TQRA8EhkKFUxBTkdVQUdFX1JFR0lPTl9BUl9BRRA9EhkKFUxBTkdVQUdFX1JFR0lPTl9BUl9FRxA+EhkKFUxBTkdVQUdFX1JFR0lPTl9BUl9NQRA/EhkKFUxBTkdVQUdFX1JFR0lPTl9BUl9EWhBAEhkKFUxBTkdVQUdFX1JFR0lPTl9QVF9CUhBGEhkKFUxBTkdVQUdFX1JFR0lPTl9QVF9QVBBHEhkKFUxBTkdVQUdFX1JFR0lPTl9SVV9SVRBQEhkKFUxBTkdVQUdFX1JFR0lPTl9SVV9CWRBREhkKFUxBTkdVQUdFX1JFR0lPTl9SVV9LWhBSEhkKFUxBTkdVQUdFX1JFR0lPTl9ISV9JThBaEhkKFUxBTkdVQUdFX1JFR0lPTl9LT19LUhBkEhkKFUxBTkdVQUdFX1JFR0lPTl9JVF9JVBBuEhkKFUxBTkdVQUdFX1JFR0lPTl9JVF9DSBBvEhkKFUxBTkdVQUdFX1JFR0lPTl9OTF9OTBB4EhkKFUxBTkdVQUdFX1JFR0lPTl9OTF9CRRB5EhoKFUxBTkdVQUdFX1JFR0lPTl9TVl9TRRCCARIaChVMQU5HVUFHRV9SRUdJT05fU1ZfRkkQgwESGQoUTEFOR1VBR0VfUkVHSU9OX0xFRVQQ5wdCV1pVZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi9pMThuL3YzO2kxOG5WM2IGcHJvdG8z");

/**
 * @generated from enum i18n.v3.LanguageRegion
 */
export enum LanguageRegion {
  /**
   * Default / unspecified
   *
   * @generated from enum value: LANGUAGE_REGION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * English variants
   *
   * United States
   *
   * @generated from enum value: LANGUAGE_REGION_EN_US = 1;
   */
  EN_US = 1,

  /**
   * United Kingdom
   *
   * @generated from enum value: LANGUAGE_REGION_EN_GB = 2;
   */
  EN_GB = 2,

  /**
   * Canada
   *
   * @generated from enum value: LANGUAGE_REGION_EN_CA = 3;
   */
  EN_CA = 3,

  /**
   * Australia
   *
   * @generated from enum value: LANGUAGE_REGION_EN_AU = 4;
   */
  EN_AU = 4,

  /**
   * India
   *
   * @generated from enum value: LANGUAGE_REGION_EN_IN = 5;
   */
  EN_IN = 5,

  /**
   * Mandarin Chinese variants
   *
   * China (Simplified)
   *
   * @generated from enum value: LANGUAGE_REGION_ZH_CN = 10;
   */
  ZH_CN = 10,

  /**
   * Taiwan (Traditional)
   *
   * @generated from enum value: LANGUAGE_REGION_ZH_TW = 11;
   */
  ZH_TW = 11,

  /**
   * Hong Kong (Traditional)
   *
   * @generated from enum value: LANGUAGE_REGION_ZH_HK = 12;
   */
  ZH_HK = 12,

  /**
   * Singapore (Simplified)
   *
   * @generated from enum value: LANGUAGE_REGION_ZH_SG = 13;
   */
  ZH_SG = 13,

  /**
   * German variants
   *
   * Germany
   *
   * @generated from enum value: LANGUAGE_REGION_DE_DE = 20;
   */
  DE_DE = 20,

  /**
   * Austria
   *
   * @generated from enum value: LANGUAGE_REGION_DE_AT = 21;
   */
  DE_AT = 21,

  /**
   * Switzerland
   *
   * @generated from enum value: LANGUAGE_REGION_DE_CH = 22;
   */
  DE_CH = 22,

  /**
   * Luxembourg
   *
   * @generated from enum value: LANGUAGE_REGION_DE_LU = 23;
   */
  DE_LU = 23,

  /**
   * Japanese
   *
   * Japan
   *
   * @generated from enum value: LANGUAGE_REGION_JA_JP = 30;
   */
  JA_JP = 30,

  /**
   * Spanish variants
   *
   * Spain
   *
   * @generated from enum value: LANGUAGE_REGION_ES_ES = 40;
   */
  ES_ES = 40,

  /**
   * Mexico
   *
   * @generated from enum value: LANGUAGE_REGION_ES_MX = 41;
   */
  ES_MX = 41,

  /**
   * Argentina
   *
   * @generated from enum value: LANGUAGE_REGION_ES_AR = 42;
   */
  ES_AR = 42,

  /**
   * Colombia
   *
   * @generated from enum value: LANGUAGE_REGION_ES_CO = 43;
   */
  ES_CO = 43,

  /**
   * Chile
   *
   * @generated from enum value: LANGUAGE_REGION_ES_CL = 44;
   */
  ES_CL = 44,

  /**
   * Peru
   *
   * @generated from enum value: LANGUAGE_REGION_ES_PE = 45;
   */
  ES_PE = 45,

  /**
   * Venezuela
   *
   * @generated from enum value: LANGUAGE_REGION_ES_VE = 46;
   */
  ES_VE = 46,

  /**
   * French variants
   *
   * France
   *
   * @generated from enum value: LANGUAGE_REGION_FR_FR = 50;
   */
  FR_FR = 50,

  /**
   * Canada
   *
   * @generated from enum value: LANGUAGE_REGION_FR_CA = 51;
   */
  FR_CA = 51,

  /**
   * Belgium
   *
   * @generated from enum value: LANGUAGE_REGION_FR_BE = 52;
   */
  FR_BE = 52,

  /**
   * Switzerland
   *
   * @generated from enum value: LANGUAGE_REGION_FR_CH = 53;
   */
  FR_CH = 53,

  /**
   * Arabic variants
   *
   * Saudi Arabia
   *
   * @generated from enum value: LANGUAGE_REGION_AR_SA = 60;
   */
  AR_SA = 60,

  /**
   * United Arab Emirates
   *
   * @generated from enum value: LANGUAGE_REGION_AR_AE = 61;
   */
  AR_AE = 61,

  /**
   * Egypt
   *
   * @generated from enum value: LANGUAGE_REGION_AR_EG = 62;
   */
  AR_EG = 62,

  /**
   * Morocco
   *
   * @generated from enum value: LANGUAGE_REGION_AR_MA = 63;
   */
  AR_MA = 63,

  /**
   * Algeria
   *
   * @generated from enum value: LANGUAGE_REGION_AR_DZ = 64;
   */
  AR_DZ = 64,

  /**
   * Portuguese variants
   *
   * Brazil
   *
   * @generated from enum value: LANGUAGE_REGION_PT_BR = 70;
   */
  PT_BR = 70,

  /**
   * Portugal
   *
   * @generated from enum value: LANGUAGE_REGION_PT_PT = 71;
   */
  PT_PT = 71,

  /**
   * Russian variants
   *
   * Russia
   *
   * @generated from enum value: LANGUAGE_REGION_RU_RU = 80;
   */
  RU_RU = 80,

  /**
   * Belarus
   *
   * @generated from enum value: LANGUAGE_REGION_RU_BY = 81;
   */
  RU_BY = 81,

  /**
   * Kazakhstan
   *
   * @generated from enum value: LANGUAGE_REGION_RU_KZ = 82;
   */
  RU_KZ = 82,

  /**
   * Hindi
   *
   * India
   *
   * @generated from enum value: LANGUAGE_REGION_HI_IN = 90;
   */
  HI_IN = 90,

  /**
   * Korean
   *
   * South Korea
   *
   * @generated from enum value: LANGUAGE_REGION_KO_KR = 100;
   */
  KO_KR = 100,

  /**
   * Italian variants
   *
   * Italy
   *
   * @generated from enum value: LANGUAGE_REGION_IT_IT = 110;
   */
  IT_IT = 110,

  /**
   * Switzerland
   *
   * @generated from enum value: LANGUAGE_REGION_IT_CH = 111;
   */
  IT_CH = 111,

  /**
   * Dutch variants
   *
   * Netherlands
   *
   * @generated from enum value: LANGUAGE_REGION_NL_NL = 120;
   */
  NL_NL = 120,

  /**
   * Belgium
   *
   * @generated from enum value: LANGUAGE_REGION_NL_BE = 121;
   */
  NL_BE = 121,

  /**
   * Swedish variants
   *
   * Sweden
   *
   * @generated from enum value: LANGUAGE_REGION_SV_SE = 130;
   */
  SV_SE = 130,

  /**
   * Finland
   *
   * @generated from enum value: LANGUAGE_REGION_SV_FI = 131;
   */
  SV_FI = 131,

  /**
   * Special case for LEE-T (Language Extension Enum - Test)
   *
   * @generated from enum value: LANGUAGE_REGION_LEET = 999;
   */
  LEET = 999,
}

/**
 * Describes the enum i18n.v3.LanguageRegion.
 */
export const LanguageRegionSchema: GenEnum<LanguageRegion> = /*@__PURE__*/
  enumDesc(file_i18n_v3_language_regions, 0);

